<template>
  <div>
    <v-row>
      <v-col class="d-flex flex-1 justify-space-between pb-5">
        <span class="header bold text-tcdc-green">{{onlineExhibition[`title_${lang}`]}}</span>
        <ShareButton mode="online-exhibition"></ShareButton>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="d-flex flex-1 align-center justify-space-between">
          <div class="d-flex flex-1" v-if="onlineExhibition.start_date && onlineExhibition.end_date || onlineExhibition.branch_id">
            <div class="pr-3 d-flex align-center" v-if="onlineExhibition.start_date && onlineExhibition.end_date">
              <img
                src="../../assets/icons/sorts/calendar.png"
                class="eventdetail-card-logo-layout1 mr-4"
              />
              <span class="bold text-uppercase text-tcdc-green">{{onlineExhibition.start_date}} - {{onlineExhibition.end_date}}</span>
            </div>
            <div class="d-flex align-center" v-if="onlineExhibition.branch_name">
              <img src="../../assets/icons/marker.png" class="eventdetail-card-logo-layout1 mr-4" />
              <span class="bold text-uppercase text-tcdc-green">{{onlineExhibition.branch_name}}</span>
            </div>
          </div>
          <div>
            <span class="text-tcdc-grey1 bold mr-4">{{$t('onlineEx.publish')}} {{onlineExhibition[`publish_date_${lang}`]}}</span>
            <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
            <span class="text-tcdc-grey1 bold">{{onlineExhibition.viewer}}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pb-0">
        <!-- <ImageCarousel /> -->
        <v-img :src="onlineExhibition.cover_image" aspect-ratio="1.7"></v-img>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col class="pt-0">
        <div
                v-html="onlineExhibition[`detail_${lang}`]"
                class="pa-8 vhtml tcdc-exhibition-background"
                :style="{ 'background': onlineExhibition.background_color ? onlineExhibition.background_color:'#2e8037' }"
        ></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span
          class="text-tcdc-grey1 bold"
        >
        <!-- TODO: Still empty -->
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ShareButton from "../buttons/ShareButton";
export default {
  components: {
    ShareButton
  },
  computed: {
      ...mapState({
        lang: state => state.Branch.lang,
        onlineExhibition: state => state.Article.onlineExhibition
      })
  }
};
</script>

<style lang="scss" scoped>
.eventdetail-card-logo-layout1 {
  height: 25px;
  object-fit: contain;
}
.tcdc-exhibition-background {
  color: #fff;
  /* background-color: $tcdcGreen; */
}
.tcdc-view-icon {
  height: 15px;
  object-fit: contain;
}
</style>
